import React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import FilledButton from '../../../shared/Buttons/FilledButton';
import OutlinedButton from '../../../shared/Buttons/OutlinedButton';
import AddIcon from '@material-ui/icons/Add';

const styles = {
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    gap: '16px',
  },
};

interface RolesActionButtonsProps
  extends RouteComponentProps,
    WithStyles<typeof styles> {}

const RolesActionButtons: React.FC<RolesActionButtonsProps> = (props) => {
  const { classes, history } = props;

  const handleAddNewRoleClick = () => {
    history.push('/addRole');
  };

  const handleAssignRoleClick = () => {
    history.push({
      pathname: '/roles',
      search: '?addUser=true',
    });
  };

  return (
    <Box className={classes.buttonsContainer}>
      <FilledButton
        icon={<AddIcon />}
        handleClick={handleAddNewRoleClick}
        text="Add New Role"
      />
      <OutlinedButton
        icon={<AddIcon />}
        handleClick={handleAssignRoleClick}
        text="Assign Role"
      />
    </Box>
  );
};

export default withRouter(
  withStyles(styles, { withTheme: true })(RolesActionButtons),
);
